var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2548_16025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 0C5.85402 0 6.42857 0.574554 6.42857 1.28571V2.57143H11.5714V1.28571C11.5714 0.574554 12.146 0 12.8571 0C13.5683 0 14.1429 0.574554 14.1429 1.28571V2.57143H16.0714C17.1362 2.57143 18 3.43527 18 4.5V6.42857H0V4.5C0 3.43527 0.863839 2.57143 1.92857 2.57143H3.85714V1.28571C3.85714 0.574554 4.4317 0 5.14286 0ZM0 7.71429H18V18.6429C18 19.7076 17.1362 20.5714 16.0714 20.5714H1.92857C0.863839 20.5714 0 19.7076 0 18.6429V7.71429ZM3.21429 10.2857C2.86071 10.2857 2.57143 10.575 2.57143 10.9286V14.7857C2.57143 15.1393 2.86071 15.4286 3.21429 15.4286H7.07143C7.425 15.4286 7.71429 15.1393 7.71429 14.7857V10.9286C7.71429 10.575 7.425 10.2857 7.07143 10.2857H3.21429Z",
    fill: "#D20F3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2548_16025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.5714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3fb8aeac37e9170e43754e9c83e3a9b4.svg";
export { ForwardRef as ReactComponent };